import { createFileRoute } from "@tanstack/react-router";
import { EnvironmentsPage } from "../features/environments/environments-page";
import { validateEnvironmentsSearch } from "../features/environments/search";

export const Route = createFileRoute("/_app/w/$workspace/environments")({
  validateSearch: validateEnvironmentsSearch,
  component: EnvironmentsPage,
});
